export const StoneLogo = ({ size = 28, className = "", subtitle = null, wordmarkSize = 15 }) => (
  <div className={`flex items-start gap-2.5 ${className}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="stoneia-logo-mark"
      className="shrink-0 mt-[2px]"
    >
      <defs>
        <linearGradient id="stoneGoldGrad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#E6C66A" />
          <stop offset="55%" stopColor="#C9A84C" />
          <stop offset="100%" stopColor="#8C7430" />
        </linearGradient>
      </defs>
      <path
        d="M16 2 L29 10 L26 26 L6 26 L3 10 Z"
        fill="url(#stoneGoldGrad)"
        stroke="#7a6325"
        strokeWidth="0.6"
      />
      <path d="M16 2 L19 14 L29 10 Z" fill="#000" opacity="0.18" />
      <path d="M6 10 L19 14 L16 26 Z" fill="#000" opacity="0.12" />
    </svg>
    <div className="flex flex-col leading-none">
      <span
        className="font-medium tracking-tight stoneia-wordmark"
        style={{
          fontFamily: "Outfit, sans-serif",
          fontSize: `${wordmarkSize}px`,
          backgroundImage:
            "linear-gradient(90deg, #C9A84C 0%, #D9BC6A 30%, #C7C7CC 65%, #E8E8E8 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          WebkitTextFillColor: "transparent",
          lineHeight: 1.05,
        }}
      >
        StoneIA
      </span>
      {subtitle && (
        <span
          className="mt-1.5"
          style={{
            color: "#C9A84C",
            fontSize: "10px",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            fontFamily: "Outfit, sans-serif",
            fontWeight: 500,
          }}
        >
          {subtitle}
        </span>
      )}
    </div>
  </div>
);

export default StoneLogo;
